import { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { isEmpty, times } from 'lodash'
import { Typography, Button, Skeleton } from '@mui/material'

import domainService from '@tabeeb/services/domainService'
import { Grid, SearchTextField } from '@collaborate-health/uikit'

const SwitchTenantContent = ({ identityMe, dialog }) => {
  const currentSubdomain = domainService.subdomain
  const [searchQuery, setSearchQuery] = useState('')

  const handleSearchQueryChange = useCallback((event) => {
    setSearchQuery(event.target.value)
  }, [])

  return (
    <Grid container direction='column' spacing={1}>
      <Grid item>
        <SearchTextField
          fullWidth
          value={searchQuery}
          onClear={() => setSearchQuery('')}
          onChange={handleSearchQueryChange}
        />
      </Grid>
      <Grid item container direction='row' spacing={1}>
        {isEmpty(identityMe) ? (
          <>
            {times(6, (index) => (
              <Grid key={index} item xs={12}>
                <Skeleton variant='text' animation='wave' height={40} />
              </Grid>
            ))}
          </>
        ) : (
          (searchQuery
            ? identityMe.userTenants.filter((userTenant) => {
                const searchQueryLowerCase = searchQuery.toLowerCase()
                return (
                  userTenant.tenantSubdomain.toLowerCase().includes(searchQueryLowerCase) ||
                  userTenant.tenantName.toLowerCase().includes(searchQueryLowerCase)
                )
              })
            : identityMe.userTenants
          ).map((userTenant) => (
            <Grid key={userTenant.tenantId} item xs={12}>
              <Button
                variant='outlined'
                sx={{ minWidth: 'unset' }}
                href={domainService.createOriginWithSubdomain(`${userTenant.tenantSubdomain}.`)}
                fullWidth
                disabled={dialog && currentSubdomain === userTenant.tenantSubdomain}
              >
                <Typography
                  title={userTenant.tenantName}
                  sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                  {userTenant.tenantName}
                </Typography>
              </Button>
            </Grid>
          ))
        )}
      </Grid>
    </Grid>
  )
}

SwitchTenantContent.defaultProps = {
  dialog: false,
}

SwitchTenantContent.propTypes = {
  identityMe: PropTypes.shape({
    userTenants: PropTypes.arrayOf(
      PropTypes.shape({
        tenantId: PropTypes.number,
        tenantName: PropTypes.string,
        tenantSubdomain: PropTypes.string,
      }).isRequired
    ),
  }),
  dialog: PropTypes.bool,
}

export default SwitchTenantContent
